import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterListByArray'
})
export class FilterListByArrayPipe implements PipeTransform {
  transform(items: any, [filtersSelected, arg]): any {
    console.log(filtersSelected.length);
    console.log(items, filtersSelected);
    if (!items || !items.length || !filtersSelected || !filtersSelected.length)
      return items;

    return items.filter((item) => filtersSelected.includes(item[arg]));
  }
}
